import React, { ReactNode } from 'react';
import useTogglesEnabledForAnyAffiliatedOrganisations from '@sekoia/shared/hooks/helpers/toggles/useTogglesEnabledForAnyAffiliatedOrganisations';
import { Redirect } from 'react-router';
import { Paths } from 'constants/Paths';
import LoadingScreen from '@sekoia/shared/components/LoadingScreen';

type Props = {
  children: ReactNode;
  toggleName: string;
};

const ToggleGuardWithRedirect = ({ toggleName, children }: Props) => {
  const {
    results: [isToggledOn],
    isLoading,
  } = useTogglesEnabledForAnyAffiliatedOrganisations(toggleName);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isToggledOn) {
    return <>{children}</>;
  }

  return <Redirect to={Paths.APP.href} />;
};

export default ToggleGuardWithRedirect;
